export enum ChatApiUrl {
    PromptImprovement = '/prompt/improve',
    ExportChatToMSWorld = '/transcript/chat/export',
    SupportedCountries = '/country/all',
}
